export class Posts {
  constructor() {
    $('.filter-posts a').click(function (e) {

      e.preventDefault();

      $('.post').fadeOut(0);

      let cat = $(this).data('cat');
      $('.filter-posts a').removeClass('active');
      $(this).toggleClass('active');

      if (cat == 'all') {
        $('.post').fadeIn();
      } else {
        $('.post').each(function () {
          if ($(this).hasClass(cat)) {
            $(this).fadeIn();
          }
        })
      }

    });

    let i;
    let arr = document.querySelectorAll('.aky-accordeon p');

    for (i = 0; i < arr.length; ++i) {
      let height = arr[i].scrollHeight;
      arr[i].style.setProperty('--max-height', height + 'px');
    }

    $('.aky-accordeon h3').click(function () {

      if (!($(this).hasClass('active'))) {
        $('.open').removeClass('open');
        $('.active').removeClass('active');
      }

      let id = $(this).data('id');

      $(this).toggleClass('active');
      $('#' + id).toggleClass('open');

    });

    if ($('.counter').length) {
      if (elementInView($('.counter'))) {
        $('.counter').each(function () {
          $(this).prop('Counter', 0).animate({
            Counter: $(this).text(),
          }, {
            duration: 7000,
            easing: 'swing',
            step: function (now) {
              $(this).text(Math.ceil(now));
            },
          });
        });
      }
    }


    function elementInView(elem) {
      let windowtop = $(window).scrollTop() + $(window).height();
      let elementop = $(elem).offset().top;
      return windowtop >= elementop;
    }

    /*$(window).scroll(function () {
      let currentScroll = $(this).scrollTop();
      if ($('.moving-step').length) {
        if (elementInView($('.moving-step'))) {
          if (currentScroll > previousScroll) {
            scroll += 2.5;
          } else {
            scroll -= 2.5;
          }
          $('.moving-step').css({'top': scroll + 'px'});
          previousScroll = currentScroll;
        } else {
          scroll = 0;
          $('.moving-step').css({'top': '0px'});
        }
      }
    });*/

    /* var top = $('.moving-step').offset().top;
     $(window).scroll(function () {
       var y = $(this).scrollTop();
         if (y >= top) {
           var difference = y - top+200;
           $('.moving-step').css('top', difference);
         }

     });
     */

    let steps_count = $('.step').length;
    //$('.moving-step').css('top',$(window).width()*0.43+'px');
    let k = 3;

    let reset =  25;
    let plus = 20;
    if($(window).width() < 490) { plus = 50; reset = 40; }

    for(let j = 0; j < 4; j++) {
      for (let i = 1; i < steps_count; i++) {
        let top = ($('.steps .step:nth-child('+k+')').offset().top - $('.steps').offset().top) + plus;
        console.log(top);
        $('.moving-step').delay(1000).animate({
            top: top+'px',
          },
          1000
        );
        k++;
      }
      $('.moving-step').delay(500).animate({
        top: reset+'px',
      },
        500
      );
      k = 3;
    }

    setTimeout(function(){
      $('.moving-step').css('z-index','10000000000');
    }, 1000);

    $('#forminator-field-upload-1_button').text('Choisir un fichier');
    $('.forminator-file-upload span').text('Aucun fichier choisi');

  }
}



// WEBPACK FOOTER //
// ./js/util/posts.js